import { DaymapQuery as n } from "../daymapQuery.js";
var r;
((d) => {
  class e extends n {
    constructor(t) {
      super(
        ["absentReasons", t.adminCodes],
        t,
        `/lms/api/attendance/absentreasons${t.adminCodes ? "?admin=true" : ""}`,
        null
      );
    }
  }
  d.absentReasons = e, ((a) => {
    a[a.NoRollMarking = 1] = "NoRollMarking", a[a.Present = 3] = "Present", a[a.UnmarkedRoll = 2] = "UnmarkedRoll", a[a.Late = 4] = "Late", a[a.Approved = 5] = "Approved", a[a.Unapproved = 6] = "Unapproved";
  })(d.AbsenceTypeEnum || (d.AbsenceTypeEnum = {}));
  class l extends n {
    constructor(t) {
      const s = [];
      t.classId && s.push(`classId=${t.classId}`), t.year && s.push(`year=${t.year}`);
      const o = s.length > 0 ? `?${s.join("&")}` : "";
      super(
        ["AttendanceMap", t.studentId, t.classId, t.year],
        t,
        `/lms/api/attendance/reports/attendancemap/${t.studentId}${o}`,
        null
      );
    }
  }
  d.AttendanceMap = l;
})(r || (r = {}));
export {
  r as attendance
};
//# sourceMappingURL=index.js.map
